<template>
  <div id="onebyone-homepage">
    <component :is="dynamicComponent"></component>
  </div>
</template>

<script>
import deviceMixins from "../mixins/deviceMixins";
import MobileHomepage from "./mobile/Homepage";
import DesktopHomepage from "./desktop/Homepage";

export default {
  mixins: [deviceMixins("Homepage")],
  components: {
    MobileHomepage,
    DesktopHomepage
  }
};
</script>